@if(this.languagesService.isTextsInitialized && this.dataService.operation.value && this.dataService.ambassador.value){

    <ion-menu contentId="app_router" side="end" menuId="main_menu" [swipeGesture]="false">
        <ion-header>
            <ion-toolbar>
                <ion-avatar id="button_menu_avatar_settings" (click)="this.goTo('settings')">
                    @if(this.dataService.ambassador.value.pictureURL && this.dataService.ambassador.value.pictureURL !== ''){
                        <img [src]="this.dataService.ambassador.value.pictureURL" />
                    }
                    @else{
                        <div class="avatar_alt">{{this.dataService.ambassador.value.firstName[0]}}{{this.dataService.ambassador.value.lastName[0]}}</div>
                    }
                </ion-avatar>
            </ion-toolbar>
        </ion-header>
        <ion-content>
            <div id="content_menu">
                <ion-list lines="none">
                    @for(menu of  this.dataService.operation.getMenu(); track $index){
                        <ion-item [id]="'button_menu_'+menu.id" [class.selected]="menu.route === this.currentRoute" (click)="this.goTo(menu.route)">
                            <ion-label>{{menu.label | translate}}</ion-label>
                        </ion-item>
                    }
                </ion-list>

                <ion-list class="deconnection_link" lines="none">
                    <ion-item id="button_menu_logout" (click)="this.logout()">
                        <ion-label>{{'HEADER.LOGOUT' | translate}}</ion-label>
                    </ion-item>
                </ion-list>
            </div>
        </ion-content>
    </ion-menu>

    <ion-header>
        <ion-toolbar>
            <div id="content_header">   
                
                @if(this.demoozNavigationService.canGoBack()){
                    <ion-buttons slot="start"> 
                        <ion-button (click)="this.goBack()">
                            <ion-icon  slot="icon-only" name="arrow-back-outline"></ion-icon>
                        </ion-button> 
                    </ion-buttons>
                }
                
                <div id="infos_profil_content">                   
                    <ion-avatar id="button_header_home" (click)="this.goTo('home')">
                        @if(this.dataService.operation.pwaLogo){
                            <img [src]="this.dataService.operation.pwaLogo" />
                        }
                        @else{
                            <div class="avatar_alt">{{this.dataService.operation.value.pwa.name[0]}}</div>
                        }
                    </ion-avatar>
                    <div id="infos_profil">
                        <div id="operation_name">{{this.dataService.operation.value.pwa.name}}</div>
                        <div id="ambassador_name">{{this.dataService.ambassador.value.firstName}}</div>
                    </div>
                </div>
                
                <ion-buttons id="header_links">
                    @for(menu of this.dataService.operation.getMenu(); track $index){
                        <ion-button [id]="'button_header_'+menu.id" [class.selected]="menu.route === this.currentRoute" (click)="this.goTo(menu.route)">{{menu.label | translate}}</ion-button>    
                    }
                </ion-buttons>
                
                <ion-avatar id="button_header_avatar_settings" (click)="this.goTo('settings')">
                    @if(this.dataService.ambassador.value.pictureURL && this.dataService.ambassador.value.pictureURL !== ''){
                        <img [src]="this.dataService.ambassador.value.pictureURL" />
                    }
                    @else{
                        <div class="avatar_alt">{{this.dataService.ambassador.value.firstName[0]}}{{this.dataService.ambassador.value.lastName[0]}}</div>
                    }
                </ion-avatar>

                <ion-buttons class="deconnection_link">                   
                    <ion-button id="button_header_logout" (click)="this.logout()">{{'HEADER.LOGOUT' | translate}}</ion-button>                        
                </ion-buttons>
                
                <ion-buttons id="btn_open_menu">
                    <ion-button id="button_header_menu" (click)="this.openMenu()">
                         <ion-icon slot="icon-only" name="menu-outline"></ion-icon>
                    </ion-button>       
                </ion-buttons>
            </div>
        </ion-toolbar>
    </ion-header>
}